import clsx from 'clsx'
import { ModalCommon } from '../../../components'
import styles from './index.module.scss'
import { Col, Row } from 'antd'
import { useMemo } from 'react'
import { LanguageEnum, PriceManagerTableKey, getDailyDivisionKey, getFLGTypeKey } from '../../../until/constant'
import { convertNumberToMoneyFormat } from '../../../until'
import { ContractorTableKey } from '..'
import { useTranslation } from 'react-i18next'
import { useDateFormat } from '../../../hooks/dateFormat'



interface IProps {
  title: string
  detailModal?: string
  visible: boolean
  onOk: () => void
  onCancel: () => void
  info: any
}

const ITEM_NOT_SHOW = ['building_id', 'id', 'type']
const ITEM_IS_COST = ['previous_water_charge', 'previous_sewerage_charge', 'transfer_cost']

export const ModalContractorDetail = ({ detailModal, visible, onOk, onCancel, info }: IProps) => {
  const { t, i18n } = useTranslation()
  const { formatDate } = useDateFormat()
  const currentLang = i18n.language
  const convertInfo = useMemo(() => {
    const arrayFirstPart: string[] = []
    const arraySecondPart: string[] = []
    if (info && !!Object.keys(info).length) {
      Object.keys(info).forEach((itemKey: string, idx: number) => {
        if (ITEM_NOT_SHOW.includes(itemKey)) return
        if (idx % 2 !== 0) {
          return arrayFirstPart.push(itemKey)
        }

        arraySecondPart.push(itemKey)
      })
    }

    return {
      arrayFirstPart,
      arraySecondPart
    }
  }, [info])
  const dailyDivisionKey = getDailyDivisionKey(t)
  const FLGType = getFLGTypeKey(t)
  const convertInfoValue = (label: string, value: string | number) => {
    switch (true) {
      case !value && value !== 0:
        return ''
      case label.includes('date') && label !== 'previous_date_meter_reading_ft':
        return formatDate(value, label === 'previous_date_meter_reading' ? 'yyyymm' : 'YYYYMMDD')
      case ITEM_IS_COST.includes(label):
        return convertNumberToMoneyFormat(value)
      case label === PriceManagerTableKey.dailyDivision:
        return dailyDivisionKey[value as keyof typeof dailyDivisionKey]
      case label === ContractorTableKey.FLG:
        return FLGType[value as keyof typeof FLGType]
      default:
        return value
    }
  }

  return (
    <ModalCommon
      title={
        `${info?.management_association_no} ${info?.building_no} ${info?.room_no} ${info?.subject_code}` || '#13254'
      }
      detailModal={detailModal}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      width={'946px'}
      destroyOnClose={true}
    >
      <div id="canvas" className={styles.modal__body}>
        <Row wrap={false} align='top' className={clsx(styles.detail__container)}>
          <Col span={12} className={styles.detail__container__col}>
            {convertInfo.arrayFirstPart.map((item: any) => {
              if (currentLang === LanguageEnum.ENGLISH) {
                return (
                  <Row key={item} align='bottom' className={styles.row_bottom}>
                    <Col className={styles.title_en}>{t(`contractors.${item}`)}:</Col>
                    <Col className={styles.value}>{convertInfoValue(item, info[item])}</Col>
                  </Row>
                )
              }
              return (
                <Row key={item} align='top'>
                  <Col span={8} className={styles.title}>{t(`contractors.${item}`)}:</Col>
                  <Col span={16}>{convertInfoValue(item, info[item])}</Col>
                </Row>
              )
            })}
          </Col>
          <Col span={12} className={styles.detail__container__col}>
            {convertInfo.arraySecondPart.map((item: string) => {
              if (currentLang === LanguageEnum.ENGLISH) {
                return (
                  <Row key={item} align='bottom' className={styles.row_bottom}>
                    <Col className={styles.title_en}>{t(`contractors.${item}`)}:</Col>
                    <Col className={styles.value}>{convertInfoValue(item, info[item])}</Col>
                  </Row>
                )
              }
              return (
                <Row key={item} align='bottom'>
                  <Col span={8} className={styles.title}>{t(`contractors.${item}`)}:</Col>
                  <Col span={16}>{convertInfoValue(item, info[item])}</Col>
                </Row>
              )
            })}
          </Col>
        </Row>
      </div>
    </ModalCommon>
  )
}
